import type { ThemeWithoutTokens } from '../theme.types';

export const cardTokens = (theme: ThemeWithoutTokens) =>
  ({
    cardRadius: theme.radiuses.l,
    cardShadow: theme.shadows.default,
  }) as const;
